import { render } from "./TaskTags.vue?vue&type=template&id=bf06eef6"
import script from "./TaskTags.vue?vue&type=script&lang=js"
export * from "./TaskTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__